import React from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { DocumentPreviewIcon } from './documentPreviewIcon';

const Thumbnails = ({ C, item, round, borderRadius, CC, alwaysDark, scale = initialScale, font = initialFont, fontName = 'Caption 1', width = '100%', height = '100%' }) => {
  const shouldApplyDarkModeColors = !!(CC && alwaysDark);

  return (
    <View
      style={[
        {
          width,
          height,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: shouldApplyDarkModeColors ? CC('Button/Dark/Secondary') : C('Button/Light/Secondary'),
          borderRadius: scale(round ? 10 : 0),
        },
        borderRadius != null && { borderRadius },
      ]}
    >
      <DocumentPreviewIcon C={C} extension={item?.extensionOriginal} scale={scale} small />
    </View>
  );
};

export default ColorWrapper(Thumbnails);
